export default __webpack_public_path__ + "./image/f870b3d392a7c518348f68fea1a589ec.svg";